import { useLingui } from '@lingui/react/macro';

/** Shared by the drawer trigger and its `Suspense` fallback, or the button changes shape as the chunk lands. */
export const MOBILE_MENU_BUTTON =
	'bg-brand text-ink cursor-pointer ml-auto grid size-12 shrink-0 place-items-center rounded-xl transition-colors hover:bg-brand-strong xl:hidden';

export function useNavLinks() {
	const { t } = useLingui();
	return [
		{ to: '/www/solutions', label: t`Solutions` },
		{ to: '/www/partner-ngos', label: t`Partner NGOs` },
		{ to: '/www/about-us', label: t`About Us` },
	] as const;
}
